// 告警中心的文案（模块 05 §4，开发计划 12 C2-04）

export const t = {
  nav: "告警",
  title: "告警中心",
  sub: "规则引擎每 10 秒检查一遍：离线、低电、故障位、遥测停了、控制权在外部。条件消失后自动恢复",
  openOnly: "只看未处理",
  robot: "机器人",
  time: "时间",
  what: "告警",
  detail: "详情",
  state: "状态",
  ack: "确认",
  acked: "已确认",
  resolved: "已恢复",
  open: "未处理",
  kinds: {
    alert_offline: "离线",
    alert_low_battery: "低电",
    alert_fault: "故障位",
    alert_telemetry_stale: "遥测停了",
    alert_control_owner: "控制权在外部",
    alert_policy_drift: "策略未生效",
  } as Record<string, string>,
  severity: { info: "提示", warning: "警告", critical: "严重" } as Record<string, string>,
  detailOf: (kind: string, p: Record<string, unknown>): string => {
    switch (kind) {
      case "alert_offline":
        return `离线超过 ${Math.round(Number(p.after_s ?? 0) / 60)} 分钟`;
      case "alert_low_battery":
        return `电量 ${String(p.battery_pct ?? "?")}%`;
      case "alert_fault":
        return `故障位 ${String(p.hex ?? p.fault_bits ?? "?")}`;
      case "alert_telemetry_stale":
        return p.last_telemetry ? `连接还在，遥测超过 ${String(p.after_s ?? "?")} 秒没来` : "连接还在，还没收到遥测";
      case "alert_policy_drift":
        return `机器人回读的策略版本 ${String(p.applied ?? "无")}，应为 ${String(p.policy_version ?? "?")}`;
      case "alert_control_owner":
        return `有云端租约，机器人侧由 ${String(p.owner ?? "?")} 持有超过 ${Math.round(Number(p.after_s ?? 0) / 60)} 分钟`;
      default:
        return "";
    }
  },
  rules: "告警参数",
  rulesHint: "本机构的机器人共用一套；改了下一轮（10 秒内）就生效",
  ruleOffline: "离线",
  ruleOfflineAfter: "离线多久告警（秒）",
  ruleLow: "低电",
  ruleLowWarn: "低于（%）告警",
  ruleLowCritical: "低于（%）严重",
  ruleFault: "故障位",
  ruleStale: "遥测停了",
  ruleStaleAfter: "遥测停多久告警（秒）",
  ruleOwner: "控制权在外部",
  ruleOwnerAfter: "遥控器或 App 持有多久告警（秒）",
  rulePolicyDrift: "策略未生效（回读不一致超过 60 秒）",
  rulesNeedOrg: "先在顶部选一个机构，再改它的告警参数",
  robotAlerts: (n: number) => `这台机器人有 ${n} 条未恢复的告警`,
  seeAlerts: "去告警中心",
  save: "保存",
  saved: "告警参数已保存",
  reset: "恢复默认",
  robotHasAlert: "有告警",
};
